import { Dialog, DialogProps } from '../../ui';

export interface ConfirmRemovePaymentMethodModalProps extends Omit<DialogProps, 'onClose'> {
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export const ConfirmRemovePaymentMethodModal: React.FC<ConfirmRemovePaymentMethodModalProps> = ({
  onConfirm,
  onCancel,
  isLoading = false,
  open,
  ...props
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      closeOnOutsideClick={!isLoading}
      className="shadow-modal backdrop:bg-modalBackdropColor !m-auto w-full max-w-md rounded-[12px] bg-white"
      {...props}
    >
      <div className="flex flex-col gap-6 p-6">
        {/* Header */}
        <div className="flex flex-col gap-2">
          <h2 className="font-['Open_Sans'] text-xl font-semibold leading-7 text-black">Are you sure?</h2>
          <p className="text-section-header-slate font-['Open_Sans'] text-sm font-normal leading-6">
            Are you sure you want to remove your payment method? You won't be able to have additional call minutes
            without adding it again.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-3">
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-button-primary hover:bg-button-primary-hover inline-flex h-10 items-center justify-center gap-1.5 rounded-full px-6 py-2.5 font-['Open_Sans'] text-base font-medium leading-5 text-white transition-colors disabled:opacity-50"
            data-testid="confirm-remove-payment-method-button"
          >
            {isLoading ? (
              <span className="flex items-center gap-2">
                <svg
                  className="h-4 w-4 animate-spin"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Removing...
              </span>
            ) : (
              'Remove payment method'
            )}
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={isLoading}
            className="bg-button-secondary text-button-primary hover:bg-button-secondary-hover inline-flex h-10 items-center justify-center gap-1.5 rounded-full px-6 py-2.5 font-['Open_Sans'] text-base font-medium leading-5 transition-colors disabled:opacity-50"
            data-testid="cancel-remove-payment-method-button"
          >
            Cancel
          </button>
        </div>
      </div>
    </Dialog>
  );
};
